export class ExecuteLegalDocumentRequest{

    public id!:number;
    public propertyId!:number;
    public auctionId?:number;
    public scheduleSeqNo?:number;
    public userId!:string;
    public documentTypeId!:number;
    public base64File!:string;
    public datafields?:string;

    constructor(){
    }
}